import * as React from "react";

import "./customizationTile.scss";
import "../customize-panel.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

import {CustomizationTileProps} from "../../build3.d";
import {AlertModal}             from "@Common/ui-components/alert-modal/alert-modal";


export const CustomizationTile = ({
    header                          = null,
    formattingModal                 = null,
    imageGuidelinesModal            = null,
    children,
    footer                          = null,
    domRef                          = undefined,
    imageType                       = null,
    photoCount                      = null,
    multiSelectOptions              = null,
    xdQaName                        = null,
    showFormattingImageGuidelines   = true,
}: CustomizationTileProps) => cs(

    consumeContext("templateOptions"),
    ["missingGalleriesModal", ({}, next) => AlertModal({
        next,
        header: "No photo gallery options currently available on this template",
        message: <>
                <p>Please email or call our support team</p>
                <p>
                    Support Email: <span className="info-span">info@xpressdocs.com</span><br/>
                    Support Phone: <span className="info-span">(866) 977-3627</span>
                </p>
            </>,
        cancelButton: false,
        xdQaName: "missingGalleryModal",
    })],

    ({templateOptions, missingGalleriesModal}) => (
        <div className="customization-tile-b45" ref={domRef}>
            {formattingModal && showFormattingImageGuidelines ? (
                <div className="customization-header">
                    {<h3 className="customization-tile-title" xd-qa-type="label" xd-qa-name={header}>{header}</h3>}
                    <div
                        className="modal-button"
                        onClick={async ()=>{
                            formattingModal.show();
                        }}
                        xd-qa-type="link"
                        xd-qa-name={xdQaName + " Formatting Help & Special Characters"}
                    >
                        Formatting Help & Special Characters
                    </div>
                </div> )
            : imageGuidelinesModal ? (
                <>  {showFormattingImageGuidelines && (
                    <div className="customization-header">
                        {<h3 className="customization-tile-title" xd-qa-type="label" xd-qa-name={header}>{header}</h3>}
                        <div
                            className="modal-button"
                            onClick={async ()=>{
                                imageGuidelinesModal.show();
                            }}
                            xd-qa-type="link"
                            xd-qa-name={xdQaName + " Image Guidelines"}
                        >
                            Image Guidelines
                        </div>
                    </div>)}
                    {!!photoCount && (
                        <div className="photo-count-line">
                            <div className="photo-count">Your template contains {photoCount} {imageType}{photoCount !== 1 && "s"}</div>
                            {!!multiSelectOptions && (
                                <button
                                    type="button"
                                    onClick={() => {
                                        if (!multiSelectOptions.allowedGalleryTabs.length) {
                                            missingGalleriesModal.show()
                                        } else {
                                            multiSelectOptions.showGallery({
                                                imageArea: {
                                                    allowedTabs: multiSelectOptions.allowedGalleryTabs,
                                                    name: "multiple",
                                                    photoQualitySettings: templateOptions.photoQualitySettings,
                                                },
                                                onApplyImages: multiSelectOptions.onApplyMultipleImagesFromPhotoDashboard,
                                                selectedImages: [], // always pass empty array - intentionally not retaining selections when re-loading the modal
                                                maxImageSelections: photoCount,
                                            })
                                        }
                                    }}
                                    xd-qa-type="button"
                                    xd-qa-name="Add Images"
                                >Add All Photos</button>
                            )}
                        </div>
                    )}
                </> )
            : (<div>{header}</div>)
            }
            <div className="customization-tile-content" xd-qa-type="card" xd-qa-name={header}>
                {children}
            </div>
            {footer}
        </div>
    )
);
